import { createVanIconComponent } from "./van"

const StopCircleOutlined = createVanIconComponent("stop-circle-o")
export default StopCircleOutlined
